/* eslint-disable */
// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptPaymentTermData, AcceptPaymentTermResponses, CancelAllRedeemMoneyData, CancelAllRedeemMoneyResponses, CancelRedeemMoneyData, CancelRedeemMoneyResponses, Capture3DsPaymentData, Capture3DsPaymentResponses, CaptureRedeemOptionData, CaptureRedeemOptionResponses, ConfirmOrderData, ConfirmOrderResponses, ConfirmPaymentUserAccountData, ConfirmPaymentUserAccountResponses, CreateAccountPaymentMethodData, CreateAccountPaymentMethodResponses, CreateNewMethodData, CreateNewMethodResponses, CreateOrderData, CreateOrderResponses, CreatePayperPaymentMethodData, CreatePayperPaymentMethodResponses, DeletePaymentMethodData, DeletePaymentMethodResponses, GetAcceptedPaymentTermsData, GetAcceptedPaymentTermsResponses, GetAeropayStatusData, GetAeropayStatusResponses, GetCryptoPaymentServiceInfoData, GetCryptoPaymentServiceInfoResponses, GetCurrencyRateData, GetCurrencyRateResponses, GetIframeSecurityDataData, GetIframeSecurityDataResponses, GetInboxNotificationsData, GetInboxNotificationsResponses, GetOffersData, GetOffersResponses, GetPaycomTokenizationSessionData, GetPaycomTokenizationSessionResponses, GetPaymentMetaInfoData, GetPaymentMetaInfoResponses, GetPaymentMethodsData, GetPaymentMethodsResponses, GetPaymentOrderData, GetPaymentOrderResponses, GetPaymentServiceBankDetailsData, GetPaymentServiceBankDetailsResponses, GetPaymentServiceInfoData, GetPaymentServiceInfoResponses, GetPendingRedeemCountData, GetPendingRedeemCountResponses, GetPurchaseHistoryData, GetPurchaseHistoryResponses, GetPurchaseLimitRequestData, GetPurchaseLimitRequestResponses, GetRedeemHistoryData, GetRedeemHistoryResponses, GetRedeemMoneyHistoryData, GetRedeemMoneyHistoryResponses, GetRedeemsRequestData, GetRedeemsRequestResponses, GetTransactionLimitRequestData, GetTransactionLimitRequestResponses, GetWidgetData, GetWidgetResponses, GetWithdrawMethodsData, GetWithdrawMethodsResponses, GetWithdrawSettingsData, GetWithdrawSettingsResponses, LinkBankAccountData, LinkBankAccountResponses, RedeemMoneyData, RedeemMoneyResponses, RefreshOrderData, RefreshOrderResponses, RegisterPaymentUserAccountData, RegisterPaymentUserAccountResponses, ResetPaymentMethodsRequestData, ResetPaymentMethodsRequestResponses, ResetPurchaseLimitRequestData, ResetPurchaseLimitRequestResponses, SetPurchaseLimitRequestData, SetPurchaseLimitRequestResponses, TokenizeApplePayData, TokenizeApplePayResponses, TokenizeGooglePayData, TokenizeGooglePayResponses, UpdateInboxNotificationData, UpdateInboxNotificationResponses, ValidateApplePayMerchantData, ValidateApplePayMerchantResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get basic payment settings.
 *
 * Returns payment setting and list of enabled purchase and redeem providers.
 */
export const getCryptoPaymentServiceInfo = <ThrowOnError extends boolean = false>(options: Options<GetCryptoPaymentServiceInfoData, ThrowOnError>) => (options.client ?? client).post<GetCryptoPaymentServiceInfoResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetCryptoPaymentServiceInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get information about bank accounts.
 *
 * Returns payment setting and list of enabled purchase and redeem providers.
 */
export const getPaymentServiceBankDetails = <ThrowOnError extends boolean = false>(options: Options<GetPaymentServiceBankDetailsData, ThrowOnError>) => (options.client ?? client).post<GetPaymentServiceBankDetailsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaymentServiceBankDetailsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get basic payment settings.
 *
 * Returns payment setting and list of enabled purchase and redeem providers.
 */
export const getPaymentServiceInfo = <ThrowOnError extends boolean = false>(options: Options<GetPaymentServiceInfoData, ThrowOnError>) => (options.client ?? client).post<GetPaymentServiceInfoResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaymentServiceInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get basic account payment info.
 *
 * Returns information on player purchase/redeem activity. E.G Check if player is first time purchaser.
 */
export const getPaymentMetaInfo = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMetaInfoData, ThrowOnError>) => (options.client ?? client).post<GetPaymentMetaInfoResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaymentMetaInfoRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get widget information for registration.
 *
 * Returns widget URL, token, and username needed for registration.
 */
export const getWidget = <ThrowOnError extends boolean = false>(options: Options<GetWidgetData, ThrowOnError>) => (options.client ?? client).post<GetWidgetResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetWidgetRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get tokenization session information.
 *
 * Returns session token needed for tokenization.
 */
export const getPaycomTokenizationSession = <ThrowOnError extends boolean = false>(options: Options<GetPaycomTokenizationSessionData, ThrowOnError>) => (options.client ?? client).post<GetPaycomTokenizationSessionResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaycomTokenizationSessionRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept payment term per account
 *
 * Save shown payment terms per account
 */
export const acceptPaymentTerm = <ThrowOnError extends boolean = false>(options: Options<AcceptPaymentTermData, ThrowOnError>) => (options.client ?? client).post<AcceptPaymentTermResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/AcceptPaymentTermRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get accepted payment terms per account
 *
 * Return accepted payment terms per account and the time, when they were accepted
 */
export const getAcceptedPaymentTerms = <ThrowOnError extends boolean = false>(options: Options<GetAcceptedPaymentTermsData, ThrowOnError>) => (options.client ?? client).post<GetAcceptedPaymentTermsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetAcceptedPaymentTermsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register payment user account.
 *
 * Register payment user account in third party system.
 */
export const registerPaymentUserAccount = <ThrowOnError extends boolean = false>(options: Options<RegisterPaymentUserAccountData, ThrowOnError>) => (options.client ?? client).post<RegisterPaymentUserAccountResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/RegisterPaymentUserAccountRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm payment user account.
 *
 * Confirm payment user account in third party system.
 */
export const confirmPaymentUserAccount = <ThrowOnError extends boolean = false>(options: Options<ConfirmPaymentUserAccountData, ThrowOnError>) => (options.client ?? client).post<ConfirmPaymentUserAccountResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ConfirmPaymentUserAccountRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link bank account to user payment methods.
 *
 * Link bank account to user payment methods.
 */
export const linkBankAccount = <ThrowOnError extends boolean = false>(options: Options<LinkBankAccountData, ThrowOnError>) => (options.client ?? client).post<LinkBankAccountResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/LinkBankAccountRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create new AeroPay payment and withdraw methods.
 *
 * Create new payment and withdraw methods.
 */
export const createNewMethod = <ThrowOnError extends boolean = false>(options: Options<CreateNewMethodData, ThrowOnError>) => (options.client ?? client).post<CreateNewMethodResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreateNewAeroPayMethodRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Aeropay status.
 *
 * Returns the current status of the user with Aeropay.
 */
export const getAeropayStatus = <ThrowOnError extends boolean = false>(options: Options<GetAeropayStatusData, ThrowOnError>) => (options.client ?? client).post<GetAeropayStatusResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetAeroPayStatusRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start capture 3ds payment.
 *
 * Capturing of 3ds payment is made when 3ds challenge is completed
 */
export const capture3DsPayment = <ThrowOnError extends boolean = false>(options: Options<Capture3DsPaymentData, ThrowOnError>) => (options.client ?? client).post<Capture3DsPaymentResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/Capture3DsPaymentOrderRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns list of offers available for purchase.
 */
export const getOffers = <ThrowOnError extends boolean = false>(options: Options<GetOffersData, ThrowOnError>) => (options.client ?? client).post<GetOffersResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetOffersRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates inbox notification status.
 *
 * FE should call this method to update status of notification returned in [Get inbox notifications](#operation/getInboxNotifications).
 *
 */
export const updateInboxNotification = <ThrowOnError extends boolean = false>(options: Options<UpdateInboxNotificationData, ThrowOnError>) => (options.client ?? client).post<UpdateInboxNotificationResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/UpdateInboxNotificationRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns list of inbox notifications available
 */
export const getInboxNotifications = <ThrowOnError extends boolean = false>(options: Options<GetInboxNotificationsData, ThrowOnError>) => (options.client ?? client).post<GetInboxNotificationsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetInboxNotificationsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create account payment method.
 *
 * This call is used for creating purchase methods, right now used only for spreedly cards.  After tokenization of card in spreedly iframe pass all card data and pay with token returned in reply.
 *
 */
export const createAccountPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<CreateAccountPaymentMethodData, ThrowOnError>) => (options.client ?? client).post<CreateAccountPaymentMethodResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreateAccountPaymentMethodRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a Payper payment method.
 *
 * Create a payment method for Payper and receive a token for subsequent purchases or redeems.
 */
export const createPayperPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<CreatePayperPaymentMethodData, ThrowOnError>) => (options.client ?? client).post<CreatePayperPaymentMethodResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreatePayperPaymentMethodRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns list purchase methods.
 *
 * Returns list of saved purchase methods that can be reused for subsequent purchases.
 */
export const getPaymentMethods = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodsData, ThrowOnError>) => (options.client ?? client).post<GetPaymentMethodsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaymentMethodsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get iFrame security payload
 *
 * Generates a security payload required to initialize a secure Spreedly iFrame.  This includes a cryptographic signature, nonce, timestamp, and the certificate token.  The frontend must call this endpoint before each iFrame initialization.
 *
 */
export const getIframeSecurityData = <ThrowOnError extends boolean = false>(options: Options<GetIframeSecurityDataData, ThrowOnError>) => (options.client ?? client).post<GetIframeSecurityDataResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetIframeSecurityDataRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete purchase method.
 *
 * Users may want to remove some of their saved methods return in [Get payment methods](#operation/getPaymentMethods). Use this API call for such scenarios. Pass either code or fingerprint.'
 *
 */
export const deletePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<DeletePaymentMethodData, ThrowOnError>) => (options.client ?? client).post<DeletePaymentMethodResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/DeletePaymentMethodRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Make a purchase.
 *
 * This resource is used to create a payment order. **Important:**  after receiving an error or first player successful purchase, payment providers must be updated: [Get payment providers](#operation/getPaymentServiceInfo)'
 *
 */
export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>) => (options.client ?? client).post<CreateOrderResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CreateOrderRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm a purchase.
 *
 * Used only for in app purchases and direct fiserv applepay, googlepay.
 */
export const confirmOrder = <ThrowOnError extends boolean = false>(options: Options<ConfirmOrderData, ThrowOnError>) => (options.client ?? client).post<ConfirmOrderResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ConfirmOrderRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh a purchase.
 *
 * Used when it is necessary to continue processing of early created transaction. It could be only for specific payment providers (f.e. AeroPay).
 */
export const refreshOrder = <ThrowOnError extends boolean = false>(options: Options<RefreshOrderData, ThrowOnError>) => (options.client ?? client).post<RefreshOrderResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/RefreshOrderRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get order info.
 *
 * For some integration, in case of redirecting back to our website this call can be used  to check transaction status using transaction id in query parameters. E.G skrill
 *
 */
export const getPaymentOrder = <ThrowOnError extends boolean = false>(options: Options<GetPaymentOrderData, ThrowOnError>) => (options.client ?? client).post<GetPaymentOrderResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPaymentOrderRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns list redeem methods.
 *
 * Returns list of saved redeem methods that can be reused for redemptions purchases.
 */
export const getWithdrawMethods = <ThrowOnError extends boolean = false>(options: Options<GetWithdrawMethodsData, ThrowOnError>) => (options.client ?? client).post<GetWithdrawMethodsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetWithdrawMethodsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start redeem creation.
 *
 * Capturing of redeem option is used for trustly only.
 */
export const captureRedeemOption = <ThrowOnError extends boolean = false>(options: Options<CaptureRedeemOptionData, ThrowOnError>) => (options.client ?? client).post<CaptureRedeemOptionResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CaptureRedeemOptionRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create redeem.
 *
 * This call is used for all subsequent redemptions using saved methods  or for those provider where redeem is initiated on our web page
 *
 */
export const redeemMoney = <ThrowOnError extends boolean = false>(options: Options<RedeemMoneyData, ThrowOnError>) => (options.client ?? client).post<RedeemMoneyResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/RedeemMoneyRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel redeem.
 *
 * After redeem creation if it wasn't locked by customer support user can cancel it.
 */
export const cancelRedeemMoney = <ThrowOnError extends boolean = false>(options: Options<CancelRedeemMoneyData, ThrowOnError>) => (options.client ?? client).post<CancelRedeemMoneyResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CancelRedeemMoneyRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel all pending redeems.
 *
 * Cancels all pending redeems for the authenticated user.
 */
export const cancelAllRedeemMoney = <ThrowOnError extends boolean = false>(options: Options<CancelAllRedeemMoneyData, ThrowOnError>) => (options.client ?? client).post<CancelAllRedeemMoneyResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/CancelAllRedeemMoneyRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get redeem money history.
 *
 * Returns redemption money history based on some filters. Please migrate to GetRedeemsRequest
 *
 * @deprecated
 */
export const getRedeemMoneyHistory = <ThrowOnError extends boolean = false>(options: Options<GetRedeemMoneyHistoryData, ThrowOnError>) => (options.client ?? client).post<GetRedeemMoneyHistoryResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetRedeemMoneyHistoryRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get redeem history.
 *
 * Returns redemption history based on some filters with pagination. Please migrate to GetRedeemsRequest.
 *
 * @deprecated
 */
export const getRedeemHistory = <ThrowOnError extends boolean = false>(options: Options<GetRedeemHistoryData, ThrowOnError>) => (options.client ?? client).post<GetRedeemHistoryResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetRedeemHistoryRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns list of available redeem providers and limit policy.
 *
 * Returns list of redeem providers and redeem limit policy(per day, daily per state) by provider configured in DB.
 */
export const getWithdrawSettings = <ThrowOnError extends boolean = false>(options: Options<GetWithdrawSettingsData, ThrowOnError>) => (options.client ?? client).post<GetWithdrawSettingsResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetWithdrawSettingsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns data about pending redeems.
 *
 * Returns the number of pending redeems and their total amount.
 */
export const getPendingRedeemCount = <ThrowOnError extends boolean = false>(options: Options<GetPendingRedeemCountData, ThrowOnError>) => (options.client ?? client).post<GetPendingRedeemCountResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPendingRedeemCountRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns FX currency rate
 *
 * Returns FX rate for player account currency
 */
export const getCurrencyRate = <ThrowOnError extends boolean = false>(options: Options<GetCurrencyRateData, ThrowOnError>) => (options.client ?? client).post<GetCurrencyRateResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetCurrencyRateRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate applepay merhcant.
 *
 * This call is part of applepay flow, when tokenizing card using apple iframe. You need validation validationResponse from reply to call completeMerchantValidation  on validate merchant callback in iframe.
 *
 */
export const validateApplePayMerchant = <ThrowOnError extends boolean = false>(options: Options<ValidateApplePayMerchantData, ThrowOnError>) => (options.client ?? client).post<ValidateApplePayMerchantResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ValidateApplePayMerchantRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tokenizing of apple pay method.
 *
 * After validating merchant in payment authorized callback make tokenize call with applepayToken.
 */
export const tokenizeApplePay = <ThrowOnError extends boolean = false>(options: Options<TokenizeApplePayData, ThrowOnError>) => (options.client ?? client).post<TokenizeApplePayResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/TokenizeApplePayRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Googlepay method tokenization.
 */
export const tokenizeGooglePay = <ThrowOnError extends boolean = false>(options: Options<TokenizeGooglePayData, ThrowOnError>) => (options.client ?? client).post<TokenizeGooglePayResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/TokenizeGooglePayRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get purchase history.
 *
 * Returns purchase history based on some filters with pagination.
 */
export const getPurchaseHistory = <ThrowOnError extends boolean = false>(options: Options<GetPurchaseHistoryData, ThrowOnError>) => (options.client ?? client).post<GetPurchaseHistoryResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPurchaseHistoryRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get redeem history.
 *
 * Returns redeem history based on some filters with pagination.
 */
export const getRedeemsRequest = <ThrowOnError extends boolean = false>(options: Options<GetRedeemsRequestData, ThrowOnError>) => (options.client ?? client).post<GetRedeemsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetRedeemsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Transaction limits.
 *
 * Returns transaction limits for a given operation (deposit or redeem).
 */
export const getTransactionLimitRequest = <ThrowOnError extends boolean = false>(options: Options<GetTransactionLimitRequestData, ThrowOnError>) => (options.client ?? client).post<GetTransactionLimitRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetTransactionLimitRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Purchase limits.
 *
 * Set deposit limits for a user (deposit).
 */
export const setPurchaseLimitRequest = <ThrowOnError extends boolean = false>(options: Options<SetPurchaseLimitRequestData, ThrowOnError>) => (options.client ?? client).post<SetPurchaseLimitRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/SetPurchaseLimitRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns Purchase limits.
 *
 * Return deposit limits for a user (deposit).
 */
export const getPurchaseLimitRequest = <ThrowOnError extends boolean = false>(options: Options<GetPurchaseLimitRequestData, ThrowOnError>) => (options.client ?? client).post<GetPurchaseLimitRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/GetPurchaseLimitsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset payment methods.
 *
 * Reset payment methods for a user.
 */
export const resetPaymentMethodsRequest = <ThrowOnError extends boolean = false>(options: Options<ResetPaymentMethodsRequestData, ThrowOnError>) => (options.client ?? client).post<ResetPaymentMethodsRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ResetAccountPaymentMethodsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Purchase limits.
 *
 * Reset deposit limits for a user (deposit).
 */
export const resetPurchaseLimitRequest = <ThrowOnError extends boolean = false>(options: Options<ResetPurchaseLimitRequestData, ThrowOnError>) => (options.client ?? client).post<ResetPurchaseLimitRequestResponses, unknown, ThrowOnError>({
    url: '/v1/dispatch/ResetPurchaseLimitsRequest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
